module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e194220"
    }
  }, [_vm._v("I Will ")]), _vm._v(" "), _c('table', {
    staticClass: "table",
    attrs: {
      "border": "0"
    }
  }, [_c('colgroup', [_c('col'), _c('col')]), _c('tbody', [_c('tr', [_c('td', [_vm._v("Pray for wisdom to know when I should practice patience.")]), _c('td', [_vm._v("yes ")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Ask God for patience when I know it’s needed in a given situation.\n")]), _c('td', [_vm._v("yes ")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Expect to find myself in situations where patience is required.\n")]), _c('td', [_vm._v("yes ")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Know that everyone faces the challenge of learning to be patient.\n")]), _c('td', [_vm._v("yes ")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Learn from past experience how impatience leads to division.\n")]), _c('td', [_vm._v("yes ")]), _c('td', [_vm._v("no")])]), _c('tr', [_c('td', [_vm._v("Look at Paul’s example to learn how to develop patience.\n")]), _c('td', [_vm._v("yes ")]), _c('td', [_vm._v("no")])])])]), _c('p', {
    staticClass: "h1l",
    attrs: {
      "id": "d7e194920"
    }
  }, [_vm._v("Things to Do ")]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e196920"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Review a recent experience that challenged your patience and examine ")]), _c('i', [_vm._v("what made being patient so difficult.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e197820"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Identify a coworker, family member, or friend and observe how this ")]), _c('i', [_vm._v("person handles patience.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e198720"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Participate in an activity once (such as playing a board game with ")]), _c('i', [_vm._v("friends) that gives you a chance to practice patience.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e199520"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" List three everyday opportunities you have to practice patience (while ")]), _c('i', [_vm._v("shopping, working, sharing a meal with friends).")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e200420"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Write a letter to God asking for more patience.")])]), _vm._v(" "), _c('p', {
    staticClass: "ul",
    attrs: {
      "id": "d7e200920"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "bu",
      "src": "images/bu.jpg"
    }
  }), _c('i', [_vm._v(" Talk with a friend you respect about how he or she practices patience.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2933f084","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Inc_9781418557720_epub_c15_r1.vue
// module id = 93
// module chunks = 0